import { createSelector } from 'reselect';
import { prop } from 'ramda';

export const selectIdleTimeoutDomain = prop('idleTimeout');

export const selectIsIdle = createSelector(
  selectIdleTimeoutDomain,
  prop('isIdle')
);
